export default __webpack_public_path__ + "static/media/mobileslide4.769aecc5.png";